var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.$t('Bundle exclusive')},model:{value:(_vm.is_bundle_exclusive),callback:function ($$v) {_vm.is_bundle_exclusive=$$v},expression:"is_bundle_exclusive"}})}
var staticRenderFns = []

export { render, staticRenderFns }